import { FC, useEffect } from "react";
import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { useAccount } from "wagmi";
import AdDetails from "../pages/AdDetails";
import AdProposalForm from "../pages/AdProposalCreation";
import AllDApps from "../pages/AllDApps";
import DAppRegister from "../pages/DAppRegister";
import DAppReport from "../pages/DAppReport";
import Details from "../pages/Details";
import AdDetailPage from "../pages/Details/AdDetailPage";
import DappDetailPage from "../pages/Details/DappDetailPage";
import Home from "../pages/Home";
import Landing from "../pages/Landing";
import MyAdDeals from "../pages/MyAdDeals";
import MyAds from "../pages/MyAds";
import VoterProfile from "../pages/VoterProfile";
import VoterRegister from "../pages/VoterRegister";

const WalletConnectedRoutes: FC = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location, performance.now()]);
  return useRoutes([
    {
      path: "/",
      children: [
        {
          path: "",
          element: <Home />,
        },
        {
          path: "/all-dapps",
          element: <AllDApps />,
        },
        {
          path: "/my-ads",
          element: <MyAds />,
        },
        {
          path: "/my-ad-deals",
          element: <MyAdDeals />,
        },
        {
          path: "/dapp-register",
          element: <DAppRegister />,
        },
        {
          path: "/voter-register",
          element: <VoterRegister />,
        },
        {
          path: "/create-ad-proposal",
          element: <AdProposalForm />,
        },
        {
          path: "/ad/:id",
          element: <AdDetailPage />,
        },
        {
          path: "/dapp-report",
          element: <DAppReport />,
        },
        {
          path: "/details/:id",
          element: <DappDetailPage />,
        },
        {
          path: "/profile",
          element: <VoterProfile />,
        },
        {
          path: "*",
          element: <Navigate to={"/"} />,
        },
      ],
    },
  ]);
};

const WalletNotConnectedRoutes: FC = () => {
  return useRoutes([
    {
      path: "/",
      children: [
        {
          path: "",
          element: <Landing />,
        },
        {
          path: "*",
          element: <Navigate to={"/"} />,
        },
      ],
    },
  ]);
};

const Router: FC = () => {
  const { isConnected } = useAccount();
  return isConnected ? <WalletConnectedRoutes /> : <WalletNotConnectedRoutes />;
};

export default Router;
